import { render } from "./BasePrice.vue?vue&type=template&id=579ce933&scoped=true"
import script from "./BasePrice.js?vue&type=script&lang=js"
export * from "./BasePrice.js?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=579ce933&scoped=true&lang=css"

import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579ce933"]])

export default __exports__